// export function formatPriceDZD(amount: number | string | null | undefined) {
//   if (amount === undefined || amount === null) return '0.00 DZD'

//   // Convert string to number if needed
//   const number = typeof amount === 'string' ? parseFloat(amount.replace(/[^0-9.]/g, '')) : amount

//   if (isNaN(number)) return '0.00 DZD'

//   // 1 Milliard = 100,000,000
//   if (number >= 100_000_000) {
//     const milliard = number / 100_000_000
//     return `${milliard % 1 === 0 ? milliard : milliard.toFixed(2)} Milliard DZD`
//   }

//   // 1 Million = 100,000
//   if (number >= 100_000) {
//     const million = number / 100_000
//     return `${million % 1 === 0 ? million : million.toFixed(2)} Million DZD`
//   }

//   // For numbers between 1,000 and 99,999
//   if (number >= 1000) {
//     const integerPart = Math.floor(number).toString()
//     const groups = []
//     let i = integerPart.length

//     while (i > 0) {
//       const start = Math.max(i - 3, 0)
//       groups.unshift(integerPart.slice(start, i))
//       i -= 3
//     }

//     return `${groups.join('.')}.00 DZD`
//   }

//   // Less than 1,000
//   return `${number.toFixed(2)} DZD`
// }

type Locale = 'en' | 'fr' | 'ar'

const translations = {
  negotiable: {
    en: 'Negotiable',
    fr: 'Négociable',
    ar: 'قابل للتفاوض',
  },
  dzd: {
    en: 'DZD',
    fr: 'DZD',
    ar: 'دج',
  },
  centimes: {
    en: 'Centimes',
    fr: 'Centimes',
    ar: 'سنتيم',
  },
  million: {
    en: 'Million Centimes',
    fr: 'Million Centimes',
    ar: 'مليون سنتيم',
  },
  milliard: {
    en: 'Milliard Centimes',
    fr: 'Milliard Centimes',
    ar: 'مليار سنتيم',
  },
}

export function formatPriceDZD(input: string | number | null | undefined, locale: Locale = 'en') {
  if (input === null || input === undefined || input === '') return `0 ${translations.dzd[locale]}`

  // Convert to number
  const amount = Number(input)
  if (isNaN(amount)) return `0 ${translations.centimes[locale]}`

  if (amount === 1) {
    return translations.negotiable[locale]
  }

  // Less than 1,000 → simple integer
  if (amount < 1000) {
    return `${amount} ${translations.dzd[locale]}`
  }

  // 1,000 to <10,000 → add dot separators
  if (amount >= 1000 && amount < 10000) {
    return `${addThousandSeparators(amount)} ${translations.centimes[locale]}`
  }

  // 10,000 to <10,000,000 → Million
  if (amount >= 10000 && amount < 10000000) {
    const million = amount / 10000
    return `${truncateDecimal(million, 3)} ${translations.million[locale]}`
  }

  // >= 10,000,000 → Milliard
  const milliard = amount / 10000000
  return `${truncateDecimal(milliard, 3)} ${translations.milliard[locale]}`
}

// Add dot separators (e.g., 1500 => 1.500)
function addThousandSeparators(num: number) {
  return num.toLocaleString('ar-DZ', { minimumFractionDigits: 0 })
}

// Truncate to n decimal places without rounding
function truncateDecimal(number: number, decimals: number) {
  const factor = Math.pow(10, decimals)
  return Math.floor(number * factor) / factor
}

// Function to format price per square meter - accepts direct price and surface values
export const formatPricePerSqm = (price: number, surface: number, locale = 'en-US') => {
  // Check if required data exists and is valid
  if (!price || !surface || price <= 0 || surface <= 0) {
    return locale === 'fr-FR' ? 'Prix non disponible' : 'Price not available'
  }

  const pricePerSqm = Math.round(price / surface)

  // Format the number with thousand separators
  const formattedPrice = pricePerSqm.toLocaleString(locale)

  return `${formattedPrice} DZD/m²`
}
